<template>
    <div v-if="filterItem && filterItem.isTypeAhead && parentFilterKey"
         class="pointer filter-type-ahead"
         :data-qe-id="`member-directory_${parentFilterKey}_${filterIndex}_handle-selected_typeahead`"
         @click.prevent="handleSelectedTypeAhead(parentFilterKey, filterItem.filterKey)" >
        <label v-if="(!isSelectedTypeAhead && !hasSelectedTypeAheadInState)"
               class="check-container ypo_blue_color">
            <span>{{filterItem.label}}</span>
            <input type="checkbox" :data-qe-id="`member-directory_${parentFilterKey}_${filterIndex}_typeahead-selector_checkbox`">
            <span class="checkmark"></span>
        </label>
        <div v-if="isSelectedTypeAhead || hasSelectedTypeAheadInState">
            <v-icon color="ypo_cta" size="24">add_circle</v-icon>
            <span class="selected-label bold-font">{{filterItem.label}}</span>
        </div>
    </div>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex';
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";

    export default {
        name: 'FilterTypeAhead',
        props: {
            filterItem: {
                type: Object,
                required: true,
            },
            parentFilterKey: {
                type: String,
                required: true,
            },
            resetSearchText: {
                type: Function,
                required: true,
            },
            filterIndex: {
                type: Number,
                default: 0,
                required: true,
            },
        },
        methods: {
            ...mapMutations({
                setSelectedTypeAhead: `memberDirectory/${storeMutation.setSelectedTypeAhead}`,
                setMemberDirectoryTypeAhead: `memberDirectory/${storeMutation.setMemberDirectoryTypeAhead}`,
            }),
            handleSelectedTypeAhead(parentKey, typeAheadKey) {
                this.resetSearchText();
                this.setMemberDirectoryTypeAhead(typeAheadKey);
                const activeTypeAhead =
                    this.typeAheadForMemberDirectory.find(item => item.key.toLowerCase() === typeAheadKey.toLowerCase());
                if (activeTypeAhead && activeTypeAhead.isActive) {
                    this.setSelectedTypeAhead({ parentKey, activeTypeAhead });
                } else {
                    this.setSelectedTypeAhead(null);
                }
            },
        },
        computed: {
            ...mapGetters({
                selectedTypeAhead: `memberDirectory/${storeGetters.selectedTypeAhead}`,
                typeAheadForMemberDirectory: `memberDirectory/${storeGetters.typeAheadForMemberDirectory}`,
                selectedFilters: `memberDirectory/${storeGetters.selectedMemberDirectoryFilters}`,
            }),
            isSelectedTypeAhead() {
                let isSelected = false;
                const {
                    selectedTypeAhead,
                    filterItem,
                    typeAheadForMemberDirectory,
                } = this;

                if (selectedTypeAhead && filterItem && filterItem.filterKey
                    && filterItem.filterKey === selectedTypeAhead.key
                    && typeAheadForMemberDirectory) {
                    const activeItem =
                        typeAheadForMemberDirectory.find(item => item.key.toLowerCase() === selectedTypeAhead.key.toLowerCase());
                    if (activeItem) {
                        isSelected = activeItem.isActive;
                    }
                }
                return isSelected;
            },
            hasSelectedTypeAheadInState() {
                const {
                    filterItem,
                    selectedFilters,
                    parentFilterKey,
                } = this;
               let hasSelected = false;
               if (filterItem && filterItem.filterKey
                   && selectedFilters && parentFilterKey && selectedFilters.hasOwnProperty(parentFilterKey)) {
                   hasSelected = selectedFilters[parentFilterKey].some(item => item.filterKey === filterItem.filterKey);
               }
               return hasSelected;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_commonClasses.scss';

    .filter-type-ahead {
        @extend %ypo_checkbox;

        .selected-label {
            color: $ypo-blue;
            font-size: 16px;
            margin-left: 10px;
        }
    }

</style>
